import { motion } from "framer-motion";
import { useAudioEffects } from "../../../hooks/use-audio-effects";
import clickSound from "../../../assets/audio/click.wav";
interface AuthButtonProps {
  label: string;
  onClick?: () => void;
  type?: "button" | "submit" | "reset";
  disabled?: boolean;
  isLoading?: boolean;
  fullWidth?: boolean;
}
export const AuthButton = ({
  label,
  onClick,
  type = "button",
  disabled = false,
  isLoading = false,
  fullWidth = true,
}: AuthButtonProps) => {
  const { playEffect } = useAudioEffects();

  const isDisabled = disabled || isLoading;

  return (
    <motion.button
      type={type}
      onClick={() => {
        if (isDisabled) return;

        playEffect(clickSound);

        if (onClick) {
          onClick();
        }
      }}
      disabled={isDisabled}
      whileHover={!isDisabled ? { filter: "brightness(1.1)" } : undefined}
      whileTap={!isDisabled ? { scale: 0.98 } : undefined}
      className={[
        "border border-[#48A7FF] rounded-md transition p-5 bg-gradient-to-b from-[#1a3e5d] to-[#4197e7] font-semibold text-[1.1rem] text-[#48A7FF]",
        fullWidth ? "w-full" : "",
        isDisabled
          ? "opacity-60 cursor-not-allowed"
          : "cursor-pointer hover:shadow-[0_4px_28px_rgba(26,107,255,0.55)]",
      ]
        .filter(Boolean)
        .join(" ")}
      aria-disabled={isDisabled}
      aria-label={label}
    >
      <span className="relative z-10 flex items-center justify-center gap-2">
        {isLoading && (
          <motion.span
            className="h-4 w-4 rounded-full border-2 border-white/30 border-t-white"
            animate={{ rotate: 360 }}
            transition={{ duration: 0.8, repeat: Infinity, ease: "linear" }}
          />
        )}
        {label}
      </span>
      {!isDisabled && (
        <motion.div
          className="absolute inset-0 bg-gradient-to-t from-transparent to-white/10"
          initial={{ opacity: 0 }}
          whileHover={{ opacity: 1 }}
          transition={{ duration: 0.2 }}
        />
      )}
    </motion.button>
  );
};
